import React from 'react'
import { Modal, FormGroup, FormControl } from 'react-bootstrap'
import {rejectProposal} from '../api'
import {getIntervalParser} from '../shared/enums/interval-enum-parser'
import {getTaskTypeIconParser} from'../shared/enums/task-type-icon-parser'

export default React.createClass({
    getInitialState: function() {
        return{
            data: {
                icon: '',
                title: '',
                content: '',
                interval: '',
                packageType: '',
                price: '',
                color: '',
            }
        }
    },
    declineProposal: function() {
        rejectProposal(this.props.modalCard.mobileTask.taskId, this.props.modalCard.messageId).then((data) => {
              if(data === 'okay') {
                  this.props.openNotificationModal('proposed-task-modal', "Declined Proposal!", "This proposal has been declined.")
                  this.props.hide()
                  this.props.refreshPage()
                }
                else {
                  this.props.openNotificationModal('proposed-task-modal', "Processing Error", "There was an error in our system. Please try again later.")
                  this.props.hide()
                }
            })
    },
    componentWillReceiveProps: function(nextProps) {
        // console.log(nextProps, 'porposedporps')
        if(nextProps.modalCard !== ''){
            let taskType = getTaskTypeIconParser(nextProps.modalCard.taskType)
            let modalIcon = taskType.iconsrc
            let intervalParsed = getIntervalParser(nextProps.modalCard.interval)
            let colorParsed = nextProps.modalCard.taskType.toLowerCase() + '-background'

            let payment = nextProps.modalCard.cost.toString()
            if(payment.length === 4) {
                payment += '0'
            }
            this.setState({icon: modalIcon, title: nextProps.modalCard.header, content: nextProps.modalCard.content, price: payment, interval: intervalParsed.capitalizedText, color: colorParsed})
        }
    },
    render: function () {

    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='my-modal-size'>
          <Modal.Header closeButton className='concrete-gray-background' style={{borderRadius: 6}}>
              <div style={{margin: 'auto', width: '90%', textAlign: 'center', marginTop: 20}} >
                <img alt='' src={this.state.icon}/>
                <h3 style={{fontWeight: 300, fontSize: 46}}>{this.state.title}</h3>
                <p className='pull-down-xs-2' style={{marginBottom: 20}}>{this.state.content}</p>
                <div className={'hidden-xs ' + this.state.color} style={{color: 'white', width: 350, height: 106, margin: 'auto', marginBottom: 40,paddingTop: 10}}>
                        <span style={{fontWeight: 100}}><b style={{fontSize: 46}}>${this.state.price}</b>/service</span>
                        <br/>
                        <span>{this.state.interval} {this.state.title}</span>
                </div>
                <div className={'visible-xs ' + this.state.color} style={{color: 'white', width: 250, height: 106, margin: 'auto', marginBottom: 40,paddingTop: 10}}>
                        <span style={{fontWeight: 100}}><b style={{fontSize: 46}}>${this.state.price}</b>/service</span>
                        <br/>
                        <span>{this.state.interval} {this.state.title}</span>
                </div>
                <p style={{fontSize: 20}}>Add any special instructions</p>
              </div>
              <div style={{margin: 'auto', width: '60%', textAlign: 'center'}}>
                <FormGroup>
                    <FormControl className='faq-text' componentClass='textarea' id='comment' placeholder='Do you have gates with codes, or any pets we need to know about? Add any extra information here if necessary.' style={{height: 111, paddingTop: 20}}/>
                </FormGroup>
                <div className='row'>
                    <div className='col-sm-6 col-xs-12 text-center'>
                        <button className='btn btn-success center-block' type='submit' onClick={() => this.props.openPayment(this.props, this.state.data, document.getElementById('comment').value)} style={{marginBottom: '20px'}}>Approve</button>
                    </div>
                    <div className='col-sm-6 col-xs-12 text-center'>
                        <button className='btn btn-info center-block' type='submit' onClick={this.declineProposal} style={{marginBottom: '20px'}}>Decline</button>
                    </div>
                </div>
              </div>
          </Modal.Header>
        </Modal>
      </div>
    )}
})



// WEBPACK FOOTER //
// ./src/components/modals/proposed-task-modal.jsx